import React from 'react'
import { IconCross } from '../../../../../../shared/components/icons/IconCross'
import { IconHamburger } from '../../../../../../shared/components/icons/IconHamburger'

export interface INavDropdownToggleProps extends React.HTMLAttributes<HTMLButtonElement> {
  active?: boolean
}

export const NavDropdownToggle = ({ active, onClick }: INavDropdownToggleProps) => {
  return (
    <button
      className='relative flex h-[36px] w-[36px] items-center justify-center rounded-[3px] bg-default'
      onClick={onClick}
    >
      <div className='w-[20px]'>{active ? <IconCross /> : <IconHamburger />}</div>
    </button>
  )
}
